import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/AdminRecentSales.css';

const SupervisorRecentSales = ({ selectedPOS }) => {
  const [recentSales, setRecentSales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchRecentSales();
  }, [selectedPOS]);

  const fetchRecentSales = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const token = localStorage.getItem('token');
      if (!token) {
        setError('No se encontró token de autenticación');
        return;
      }

      // Build URL with POS filter
      const params = new URLSearchParams();
      if (selectedPOS && selectedPOS !== 'all') {
        params.append('pointOfSaleId', selectedPOS);
      }
      
      const url = `/api/supervisors/recent-sales${params.toString() ? `?${params.toString()}` : ''}`;
      console.log('SupervisorRecentSales: Consultando URL:', url);
      
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      console.log('SupervisorRecentSales: Respuesta recibida:', response.data);
      setRecentSales(response.data || []);
    } catch (error) {
      console.error('Error al cargar ventas recientes:', error);
      setError('Error al cargar ventas recientes');
      setRecentSales([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Fecha no disponible';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('es-MX', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC'
      });
    } catch (error) {
      return dateString;
    }
  };

  const formatCurrency = (amount) => {
    if (!amount) return '$0.00';
    return `$${parseFloat(amount).toLocaleString('es-MX', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  if (loading) {
    return (
      <div className="recent-sales-container">
        <h3>Movimientos Recientes</h3>
        <div className="loading-container">
          <p>Cargando ventas recientes...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="recent-sales-container">
        <h3>Movimientos Recientes</h3>
        <div className="error-container">
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="recent-sales-container">
      <h3>Movimientos Recientes</h3>
      {recentSales && recentSales.length > 0 ? (
        <div className="recent-sales-table-container">
          <table className="recent-sales-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Fecha</th>
                <th>Punto de Venta</th>
                <th>Tipo</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {recentSales.map((sale, index) => (
                <tr key={sale.id || index}>
                  <td>{index + 1}</td>
                  <td>{formatDate(sale.sale_fecha)}</td>
                  <td>{sale.points_of_sale?.pos_name || 'N/A'}</td>
                  <td>
                    <span className="sale-type">
                      {sale.type || 'Venta'}
                    </span>
                  </td>
                  <td className="total-amount">
                    {formatCurrency(sale.total)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="no-data-container">
          <p>No hay ventas recientes disponibles</p>
        </div>
      )}
    </div>
  );
};

export default SupervisorRecentSales;
